<template>
    <div v-if="authenticated() && ((user && user.stripe_subscription) || !!user.stripe_subscription === false)">

      <p class="body-1 mt-6">{{ $t("Please enter your new card details below") }}. {{ $t("They will be stored securely with our payment gateway") }}.</p>

      <v-sheet rounded outlined class="pa-3 mt-4">
        <div id="payment-element"></div>
      </v-sheet>
      <p id="card-error" role="alert" class="red--text pa-2"></p>

      <v-btn class="mt-4" block elevation="0" color="primary" @click='update' :loading="loading"
             :disabled="loading">{{ $t('buttons.Update card') }}</v-btn>


    </div>
</template>

<script>

import { stripeService, userService } from '../services'
import { mapState, mapGetters, mapActions } from 'vuex'

import { store } from '../store';
import {i18n} from "../i18n";

import { loadStripe } from '@stripe/stripe-js'

export default {
  name: "UpdateCard",
  props: ['dialogOpen'],
  data: () => ({
    mountStripeElement: false,
    stripeKey: process.env.VUE_APP_STRIPE_KEY,
    complete: false,
    declined: false,
    loading: false,
    snack: false,
    snackColor: '',
    snackText: '',
    name: '',
    valid: false,
    stripe: null,
    elementsObject: null,
    clientSecretObject: null,
    paymentFormLoaded: false
  }),
  mounted () {
    console.log(this.dialogOpen)
    this.mountStripeElement = true;
    this.name = this.user.default_payment_method ? this.user.default_payment_method.name : this.user.name

    stripeService.updateCardIntent().then(intent => {
      this.clientSecret = intent.client_secret
      console.log(this.clientSecret)

      const options = {
        clientSecret: this.clientSecret
      };

      this.loadPaymentForm ()

      let style = {
        base: {
          iconColor: '#333',
          color: '#000',
          fontWeight: '500',
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          ':-webkit-autofill': {
            color: '#fce883',
          },
          '::placeholder': {
            color: '#999',
          },
        },
        invalid: {
          iconColor: '#FF0000',
          color: '#FF0000',
        },
      }

      if (this.brand === 'neotag') {
        style = {
          base: {
            iconColor: '#c4f0ff',
            color: '#fff',
            fontWeight: '500',
            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            ':-webkit-autofill': {
              color: '#fce883',
            },
            '::placeholder': {
              color: '#47ccf9',
            },
          },
          invalid: {
            iconColor: '#FF0000',
            color: '#FF0000',
          },
        }
      }

      this.card = this.elements.create('card', {
        style: style,
      });
      this.card.mount(this.$refs.card);

      let that = this

      this.card.on("change", function (event) {
        // Disable the Pay button if there are no card details in the Element
        //document.querySelector("button").disabled = event.empty;
        that.loading = false
        document.querySelector("#card-error").textContent = event.error ? event.error.message : "";
      });
    })

  },
  computed: {
    ...mapState({
      user: state => state.account.user,
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    ...mapGetters('account', ['hasMembership'])
  },
  methods: {
    ...mapActions('account', ['updateSelf', 'updateMembership', 'updateSubscription']),
    ...mapActions('basket', ['addSilent']),
    async loadPaymentForm () {
      this.stripe = await loadStripe(this.stripeKey);

      stripeService.updateCardIntent().then(response => {

        this.clientSecretObject = response.client_secret
        console.log(this.clientSecretObject)
        let clientSecret = this.clientSecretObject

        const appearance = {
          theme: this.brand.neotag ? 'night' : 'default'
        };
        const options = { /* options */ };
        let elements = this.stripe.elements({ clientSecret, appearance });
        this.elementsObject = elements
        console.log(this.elementsObject)
        const paymentElement = elements.create('payment', options);
        paymentElement.mount('#payment-element');
        this.paymentFormLoaded = true

      }).catch(function (error) {
        console.log(error)
        //that.$emit('update-card-error', 'Error')
      });
    },
    authenticated () {
      return store.state.authenticated
    },
    update() {

      this.loading = true
      let that = this
      let elements = this.elementsObject

      this.stripe.confirmSetup({
        elements,
        redirect: 'if_required'
      }).then(function (result) {
        // Handle result.error or result.paymentIntent
        console.log(result)

        if (result.error) {
          store.dispatch('alert/success', i18n.t('Sorry an error occurred'), {root: true});
          console.log(result.setupIntent)
        } else {

          stripeService.updateCard(result.setupIntent.payment_method).then(response => {
            console.log(response)

            that.loading = false
            store.dispatch('alert/success', i18n.t('Your card has been updated'), {root: true});
            that.$emit('close-update-card', response.data)


          })
        }
      });

      // this.$refs.observer.validate().then(success => {
      //   if (this.valid) {
      //     this.loading = true
      //     let that = this
      //     let card = this.card
      //     let name = this.name
      //
      //     stripe.confirmCardSetup(this.clientSecret, {
      //           payment_method: {
      //             card: card,
      //             billing_details: {
      //               name: name,
      //             },
      //           }
      //         }
      //
      //     ).then(function (result) {
      //       // Handle result.error or result.paymentIntent
      //       console.log(result)
      //
      //       if (result.error) {
      //         store.dispatch('alert/success', i18n.t('Sorry an error occurred'), {root: true});
      //         console.log(result.setupIntent)
      //       } else {
      //
      //         stripeService.updateCard(result.setupIntent.payment_method).then(response => {
      //           console.log(response)
      //
      //           that.loading = false
      //           store.dispatch('alert/success', i18n.t('Your card has been updated'), {root: true});
      //           that.$emit('close-update-card', response.data)
      //
      //
      //         })
      //       }
      //     });
      //   }
      // })


    }
  },
  watch: {
    dialogOpen (val) {
      console.log(val)
    }
  },
}
</script>

<style scoped>
    .stripe-card {
      /*width: 300px;*/
      border: 1px solid grey !important;
      box-sizing: border-box;

      height: 40px;

      padding: 10px 12px;
      margin: 20px 0;

      border: 1px solid transparent;
      border-radius: 4px;
      background-color: white;

      box-shadow: 0 1px 3px 0 #e6ebf1;
      -webkit-transition: box-shadow 150ms ease;
      transition: box-shadow 150ms ease;
    }
    .stripe-card.complete {
      border-color: green !important;
    }
    .stripe-card.complete.declined {
      border-color: red !important;
    }

    .stripe-card--focus {
      box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .stripe-card--invalid {
      border-color: #fa755a;
    }

    .stripe-card--webkit-autofill {
      background-color: #fefde5 !important;
    }

    .pay-with-stripe {
      display: block;
      background: #666ee8;
      color: #000;
      box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      border: 0;
      font-weight: 700;
      width: 100%;
      height: 40px;
      outline: none;
      cursor: pointer;
      transition: all 0.15s ease;
    }

    .pay-with-stripe:focus {
      background: #555abf;
    }

    .pay-with-stripe:hover {
      transform: translateY(-1px);
      box-shadow: 0 7px 14px 0 rgba(50, 50, 93, 0.1),
      0 3px 6px 0 rgba(0, 0, 0, 0.08);
    }

    .clear-button {
      margin-top: 20px;
    }
</style>
